export default "__VITE_ASSET__IZqdBnB7__"